export function addCurrent(segment) {
    return {
        type: 'ADD_CURRENT',
        segment,
    }
}
